<template>
    <v-btn @click="dialog = !dialog" color="green" dark>
        Lắp mới Internet
        <v-dialog v-model="dialog" max-width="90%">
            <app-card>
                <app-section-loader :status="loading.submit"></app-section-loader>
                <h4>PHIẾU LẮP MỚI INTERNET</h4>
                <p class="fs-14 grey--text">Tạo phiếu lắp mới internet</p>
                <v-form ref="form">
                    <v-container fluid>
                        <v-layout row wrap justify-center>
                            <v-flex xs12 md3>
                                <v-select label="Tòa nhà" :disabled="loading.submit" v-model="form.building"
                                    :items="list_building" prepend-icon="domain" :rules="[rules.required]"
                                    required></v-select>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-autocomplete label="Số phòng" :disabled="loading.submit" v-model="form.room_id"
                                    :items="room_ids" item-text="room_id" item-value="rooms_id"
                                    prepend-icon="meeting_room" :rules="[rules.required]" required></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field label="Tên user" :disabled="loading.submit" v-model="form.user"
                                    prepend-icon="account_box" :rules="[rules.required]"></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field label="Gói cước" :disabled="loading.submit" v-model="form.price"
                                    prepend-icon="money" :rules="[rules.required]" v-currency></v-text-field>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-text-field label="Tên gói cước" :disabled="loading.submit"
                                    v-model="form.package_name" prepend-icon="label"></v-text-field>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-text-field label="Tốc độ (Mbps)" :disabled="loading.submit" v-model="form.speed_mbps"
                                    prepend-icon="speed" type="number"></v-text-field>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-text-field label="Số người ở" :disabled="loading.submit"
                                    v-model="form.number_of_residents" prepend-icon="people" type="number"
                                    :rules="[rules.required]"></v-text-field>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-text-field label="Số chứng từ giấy" :disabled="loading.submit" v-model="form.receipt_code"
                                    prepend-icon="receipt" :rules="[rules.required]" required></v-text-field>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-text-field label="Mã chứng từ" :disabled="true" v-model="form.receipt_id"
                                    prepend-icon="receipt_long"></v-text-field>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-text-field label="Tên wifi" :disabled="loading.submit" v-model="form.wifi_name"
                                    prepend-icon="wifi" required :rules="[rules.required]"></v-text-field>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-text-field label="Password Wifi" :disabled="loading.submit"
                                    v-model="form.wifi_password" prepend-icon="lock" required
                                    :rules="[rules.required]"></v-text-field>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-menu :close-on-content-click="false" v-model="menu_date_start" :nudge-right="40" lazy
                                    transition="scale-transition" offset-y full-width min-width="290px">
                                    <v-text-field slot="activator" v-model="form.date_start" label="Ngày thực tế lắp"
                                        :disabled="loading.submit" prepend-icon="event" readonly></v-text-field>
                                    <v-date-picker locale="vi-VI" v-model="form.date_start"
                                        @input="menu_date_start = false"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-text-field label="Giá thu KH" :disabled="loading.submit"
                                    v-model="form.customer_price" prepend-icon="money" v-currency></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="loading.submit" @click="cancelInput">
                            Trở về
                        </v-btn>
                        <v-btn :loading="loading.submit" :disabled="loading.submit" @click="submit" color="green" dark>
                            Lắp mới
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </app-card>
        </v-dialog>
    </v-btn>
</template>
<script>
import api from "Api";
import { list_building, WIFI_TYPES } from 'Constants/db-config';
import { formatCurrency, buildParamQuery, parseCurrency  } from 'Helpers';
const basements = [
    { room_id: 'tang-ham-gb', building: "GB" },
    { room_id: 'tang-ham-tt', building: "TT" },
    { room_id: 'tang-ham-ma', building: "MA" },
    { room_id: 'tang-ham-xa', building: "XA" },
    { room_id: 'tang-ham-bn', building: "BN" },
]

export default {
    name: "create-internet",
    data() {
        return {
            dialog: false,
            menu_date_start: false,
            rules: {
                required: value => !!value || 'Vui lòng điền thông tin này.',
            },
            form: {
                building: '',
                room_id: '',
                price: '',
                user: '',
                speed_mbps: '',
                package_name: '',
                number_of_residents: '',
                date_start: '',
                note: '',
                wifi_type: WIFI_TYPES.PRIVATE,
                receipt_code: '',
                receipt_id: '',
                wifi_name: '',
                wifi_password: '',
                customer_price: '',
            },
            list_building,
            alert: {
                show: false,
                text: '',
                type: 'error'
            },
            loader: false,
            loading: {
                submit: false
            },
            formatCurrency
        }
    },
    computed: {
        rooms() {
            return this.$store.state.app.rooms.concat(basements)
        },
        room_ids() {
            return this.rooms.filter(room => room.building === this.form.building)
        }
    },
    watch: {
        dialog(nv) {
            if (!nv) this.$refs.form.reset();
        },
        "form.receipt_code"(nv) {
            if (nv && this.form.building) {
                const buildingCode = this.form.building === 'MT' ? 'MA' : this.form.building;
                this.form.receipt_id = buildingCode + '.' + nv + ".MA";
            }
        },
        "form.building"(nv) {
            if (nv && this.form.receipt_code) {
                const buildingCode = nv === 'MT' ? 'MA' : nv;
                this.form.receipt_id = buildingCode + '.' + this.form.receipt_code + ".MA";
            }
        },
        'form.room_id': {
            immediate: false,
            async handler(newVal) {
                if (!newVal || !this.form.building) return;
                try {
                    const params = { room_id: newVal, building: this.form.building }
                    const query = buildParamQuery(params)
                    const { data, status } = await api.getListInternet(query);
                    if (status === 200 && data.internet && data.internet.length) {
                        const item = data.internet[0];
                        this.form.wifi_type = item.wifi_type || this.form.wifi_type;
                        if (item.receipt_id) this.form.receipt_id = item.receipt_id;
                        if (item.receipt_code) this.form.receipt_code = item.receipt_code;
                        if (item.wifi_name) this.form.wifi_name = item.wifi_name;
                        if (item.wifi_password) this.form.wifi_password = item.wifi_password;
                        if (item.number_of_residents) this.form.number_of_residents = item.number_of_residents;
                        if (item.package_name) this.form.package_name = item.package_name;
                        if (item.speed_mbps) this.form.speed_mbps = item.speed_mbps;
                        if (item.price) this.form.price = item.price;
                        if (item.note) this.form.note = item.note;
                    }
                } catch (e) {
                    console.error('Fetch pending internet by room failed', e);
                }
            }
        },
    },
    methods: {
        cancelInput() {
            this.dialog = false
            this.$refs.form.reset();
        },
        async submit() {
            if (!this.$refs.form.validate()) {
                swal.fire('Lỗi', 'Vui lòng điền đầy đủ thông tin', 'error');
                return
            }
            try {
                const postData = {
                    ...this.form,
                    price: parseCurrency(this.form.price, "vi-VN", 'VND'),
                    speed_mbps: this.form.speed_mbps ? Number(this.form.speed_mbps) : null,
                    package_name: this.form.package_name || '',
                    number_of_residents: this.form.number_of_residents ? Number(this.form.number_of_residents) : 1,
                    date_start: this.form.date_start || new Date().toISOString(),
                    note: this.form.note || '',
                    wifi_type: this.form.wifi_type,
                    receipt_code: this.form.receipt_code,
                    receipt_id: this.form.receipt_id,
                    wifi_name: this.form.wifi_name,
                    wifi_password: this.form.wifi_password,
                    customer_price: this.form.customer_price ? parseCurrency(this.form.customer_price, "vi-VN", 'VND') : null,
                    renewal_start_date: this.form.date_start || new Date().toISOString(),
                }
                this.loading.submit = true;
                console.log(postData);
                const data = await api.createInternet(postData)
                this.loading.submit = false;
                if (data.status === 200) {
                    const message = (data.data && data.data.message) || data.message || 'Tạo phiếu lắp mới Internet thành công';
                    swal.fire('Thành công', message, 'success');
                    this.dialog = false;
                    this.$emit('reloadTable');
                } else {
                    swal.fire('Lỗi', data.message || 'Có lỗi xảy ra khi tạo phiếu', 'error');
                }
            } catch (error) {
                this.loading.submit = false;
                console.error("Submit error:", error);
                swal.fire('Lỗi', error.message || 'Có lỗi xảy ra khi tạo phiếu', 'error');
            }
        }
    }
}
</script>